const getters = {
  candidateDetails: state => {
    return state.candidateDetails
  },
  candidateDossierDetails: state => {
    return state.candidateDossierDetails
  },
  isCloseup: state => {
    return state.isCloseup
  },
  closeupDetails: state => {
    return state.closeupDetails
  },
  candidateInfo: state => {
    return state.candidateInfo
  },
  closeupCount: state => {
    return state.closeupCount
  }
}
export default getters
